/* Hobolax: auto-advance to the next step once an item is added (Rob 09-22). Final step is left to the shopper.
   Works on desktop and mobile: counts the bundle from EB's sessionStorage box, falls back to the footer counter. */
(function () {
  if (window.__hbxAutoNext) return;
  window.__hbxAutoNext = true;
  function count() {
    var n = 0, found = false;
    try {
      Object.keys(sessionStorage).forEach(function (k) {
        if (k.indexOf('gbbSdk-cart-') !== 0) return;
        var d = JSON.parse(sessionStorage.getItem(k) || '{}');
        if (d && d.items) { found = true; d.items.forEach(function (it) { n += (it.quantity || 1); }); }
      });
    } catch (e) {}
    if (found) return n;
    var el = document.querySelector('.gbbFooterTotalItemsInCart, .gbbCartQuantity');
    var m = el && el.textContent.match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }
  function nextBtn() {
    /* Rob 09-24: the Next button is now HIDDEN until the final add-to-cart step, so
       this can no longer require getClientRects() -- that check would return null and
       auto-advance would silently stop. Prefer a visible one, fall back to a hidden one. */
    var bs = document.querySelectorAll('.gbbFooterNextButton'), fallback = null;
    for (var i = 0; i < bs.length; i++) {
      var t = (bs[i].textContent || '').trim().toLowerCase();
      if (t.indexOf('next') !== 0) continue;
      if (bs[i].getClientRects().length) return bs[i];
      if (!fallback) fallback = bs[i];
    }
    return fallback;
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('.gbbProductAddButton')) return;
    var before = count();
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (count() > before) {
        clearInterval(timer);
        setTimeout(function () {
          var nb = nextBtn();
          if (nb) { nb.click(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
        }, 450);
      } else if (tries > 20) {
        clearInterval(timer);
      }
    }, 150);
  }, true);
})();

/* Hobolax 09-24 (Rob): switching Adult <-> Youth jumped the page.
   History, so nobody re-walks it:
     - Not a reflow (doc height GREW 5744 -> 6191), and blocking window.scrollTo /
       scrollBy / scroll / Element.scrollIntoView / the scrollTop setter all
       failed to stop it. So we correct the position rather than fight the cause.
     - ⛔ v1 clamped every 16ms for 1500ms and FROZE the shopper's own scrolling
       for a second or two (Rob, round 3). A sustained clamp is never acceptable.
     - ⛔ Do not use requestAnimationFrame: offscreen Chrome fires it ~3x in 2s
       (vs 125 setInterval ticks), so a rAF pin silently never runs.
   This is now a ONE-SHOT correction: look once, shortly after a category tab
   click, and only snap back if the page jumped a long way on its own. Any user
   gesture before that cancels it, and nothing is ever held. */
(function () {
  if (window.__hbxPinCatScroll) return;
  window.__hbxPinCatScroll = true;
  var rawTo = window.scrollTo.bind(window);
  var pending = null;

  function cancel() { if (pending) { clearTimeout(pending); pending = null; } }
  ['wheel', 'touchstart', 'touchmove', 'keydown', 'pointerdown', 'mousedown'].forEach(function (evt) {
    window.addEventListener(evt, cancel, { capture: true, passive: true });
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.gbbCategoryTabContainer, .gbbCategoriesTabsContainer, .gbbCategoryTabTitle')) return;
    cancel();
    var y = window.scrollY;
    pending = setTimeout(function () {
      pending = null;
      // only undo a big unrequested jump; ignore small settling
      if (Math.abs(window.scrollY - y) > 150) rawTo(0, y);
    }, 140);
  }, true);
})();

/* Hobolax 09-24 (Rob): brand header above the step icons -- ADULT & YOUTH star,
   the HOBOLAX FALL BUNDLE logo, ONLY $99! star. EB has no setting for this and its
   own "Custom JS" is injected with innerHTML so a <script> there NEVER runs, which
   is why this lives in a real theme asset. Inserted as the first child of
   .gbbBundleHeader so it sits above the step nav without touching EB's own markup. */
(function () {
  if (window.__hbxBundleHeader) return;
  window.__hbxBundleHeader = true;
  var CDN = 'https://cdn.shopify.com/s/files/1/0585/7447/1358/files/';
  function build() {
    var host = document.querySelector('.gbbBundleHeader');
    if (!host || host.querySelector('.hbx-fb-header')) return;
    var wrap = document.createElement('div');
    wrap.className = 'hbx-fb-header';
    wrap.innerHTML =
      '<img class="hbx-fb-badge" src="' + CDN + 'fb-badge-adult-youth.png" alt="Adult and Youth">' +
      '<img class="hbx-fb-logo"  src="' + CDN + 'fb-header-logo.png" alt="Hobolax Fall Bundle">' +
      '<img class="hbx-fb-badge" src="' + CDN + 'fb-badge-only99.png?v=1790252959" alt="Only $99">';
    host.insertBefore(wrap, host.firstChild);
    if (!document.getElementById('hbx-fb-header-css')) {
      var s = document.createElement('style');
      s.id = 'hbx-fb-header-css';
      s.textContent =
        '.hbx-fb-header{display:flex;align-items:center;justify-content:center;gap:10px;' +
        'width:100%;padding:4px 6px 10px;box-sizing:border-box;}' +
        '.hbx-fb-header .hbx-fb-logo{width:52%;max-width:420px;height:auto;flex:0 1 auto;}' +
        '.hbx-fb-header .hbx-fb-badge{width:20%;max-width:150px;height:auto;flex:0 0 auto;}' +
        '@media (max-width:749px){.hbx-fb-header{gap:6px;padding:2px 4px 8px;}' +
        '.hbx-fb-header .hbx-fb-logo{width:54%;}.hbx-fb-header .hbx-fb-badge{width:21%;}}';
      document.head.appendChild(s);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else { build(); }
  var tries = 0;
  var iv = setInterval(function () { build(); if (++tries > 40 || document.querySelector('.hbx-fb-header')) clearInterval(iv); }, 300);
})();

/* Hobolax 09-24 (Rob): hide the footer button while it reads "Next - $99" -- that label
   means nothing to a shopper, and our auto-advance already moves the step for them. It
   reappears on the last step when it becomes the real Add To Cart. The footer's progress
   line ("Add 3 product(s) to get the bundle at $99") is left visible. */
(function () {
  if (window.__hbxFooterBtn) return;
  window.__hbxFooterBtn = true;
  if (!document.getElementById('hbx-footer-btn-css')) {
    var s = document.createElement('style');
    s.id = 'hbx-footer-btn-css';
    s.textContent = '.hbx-hide-next .gbbFooterButtonsWrapper{display:none !important;}'
      /* Rob 09-24: the Smile.io rewards launcher floats over the builder and is in the way
         here. This file is loaded ONLY on the bundle product (handle guard in theme.liquid),
         so hiding it is scoped to this page and the rewards widget stays everywhere else. */
      + '#smile-ui-lite-container,#smile-ui-container{display:none !important;}';
    document.head.appendChild(s);
  }
  function boxCount() {
    var n = 0;
    try {
      Object.keys(sessionStorage).forEach(function (k) {
        if (k.indexOf('gbbSdk-cart-') !== 0) return;
        var d = JSON.parse(sessionStorage.getItem(k) || '{}');
        if (d && d.items) d.items.forEach(function (it) { n += (it.quantity || 1); });
      });
    } catch (e) {}
    return n;
  }
  function required() {
    var n = document.querySelectorAll('.gbbNavigationItem').length;
    return n > 0 ? n : 3;
  }
  function sync() {
    /* Rob 09-24: ADD TO CART must only appear once the LAST item (the joggers) is in the
       box -- EB flips the label as soon as you land on the final step, which showed the
       button while the bundle was still incomplete. Hide while the label is "Next", and
       also while the box is short of one item per step. */
    var complete = boxCount() >= required();
    var bs = document.querySelectorAll('.gbbFooterNextButton');
    for (var i = 0; i < bs.length; i++) {
      var wrap = bs[i].closest('.gbbFooterActionContainer') || bs[i].parentElement;
      if (!wrap) continue;
      var t = (bs[i].textContent || '').trim().toLowerCase();
      wrap.classList.toggle('hbx-hide-next', t.indexOf('next') === 0 || !complete);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else { sync(); }
  setInterval(sync, 400);
  new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* Hobolax 09-24 (QA): a card whose options are not ALL chosen has an empty
   dataset.variantId, and EB's "Add to Bundle" then does NOTHING -- no error, no
   disabled state, no highlight. On a multi-colour product (Clean Drip Hoodie etc.)
   a shopper who picks a size but skips the little colour swatch just taps a dead
   button and assumes the site is broken. Single-colour products auto-fill their
   colour, so the behaviour is inconsistent card to card, which makes it worse.
   This dims the button until the card can resolve a variant, and on a dead tap
   points at the option row that is still empty. */
(function () {
  if (window.__hbxOptGuard) return;
  window.__hbxOptGuard = true;
  if (!document.getElementById('hbx-opt-guard-css')) {
    var s = document.createElement('style');
    s.id = 'hbx-opt-guard-css';
    s.textContent =
      '.hbx-need-opts .gbbProductAddButton{opacity:.45 !important;}' +
      '.hbx-opt-flash{outline:2px solid #ff14b8 !important;outline-offset:3px;border-radius:6px;}' +
      '.hbx-opt-hint{color:#ff14b8;font-size:12px;font-weight:700;margin-top:2px;}' +
      /* Rob 09-24: the bundle parent is now LISTED and pinned first in Lacrosse Hoodies,
         T-Shirts and Lacrosse Sweatpants — which are the very collections driving the
         adult steps of this builder. Hide the bundle's own card so it can't be picked
         as an item inside itself. Matched on product id, not title. */
      '.gbbProductItem[data-product-id="9871803089126"]{display:none !important;}';
    document.head.appendChild(s);
  }
  function unsetRow(card) {
    var vals;
    try { vals = JSON.parse(card.dataset.optionValues || '[]'); } catch (e) { return null; }
    for (var i = 0; i < vals.length; i++) {
      if (vals[i] === '' || vals[i] == null) {
        return card.querySelector('.gbbOptionPickerRow[data-option-position="' + (i + 1) + '"]');
      }
    }
    return null;
  }
  function scan() {
    var cards = document.querySelectorAll('.gbbProductItem');
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.toggle('hbx-need-opts', !cards[i].dataset.variantId);
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.gbbProductAddButton');
    if (!btn) return;
    var card = btn.closest('.gbbProductItem');
    if (!card || card.dataset.variantId) return;
    var row = unsetRow(card);
    if (!row) return;
    row.scrollIntoView({ block: 'center', behavior: 'smooth' });
    row.classList.add('hbx-opt-flash');
    setTimeout(function () { row.classList.remove('hbx-opt-flash'); }, 1600);
    if (!row.querySelector('.hbx-opt-hint')) {
      var lbl = row.querySelector('.gbbOptionPickerRowLabel');
      var name = lbl ? lbl.textContent.replace(/:.*$/, '').trim() : 'an option';
      var h = document.createElement('div');
      h.className = 'hbx-opt-hint';
      h.textContent = 'Choose a ' + name.toLowerCase() + ' first';
      row.appendChild(h);
      setTimeout(function () { h.remove(); }, 3500);
    }
  }, true);
  scan();
  setInterval(scan, 400);
})();

/* Hobolax 09-24 (Rob): the Klaviyo "10% off" signup popup covers the bottom of the
   bundle builder, right where the step footer and Add To Cart live. Klaviyo's onsite
   JS is an APP EMBED, so it cannot be turned off per-page from the theme — instead we
   strip its FLOATING forms here. This file only loads on the bundle product, so the
   popup keeps working everywhere else on the store.
   ⛔ Only fixed/absolute-positioned Klaviyo containers are removed. The footer
   "Unlock early access" signup is an INLINE Klaviyo embed and must survive. */
(function () {
  if (window.__hbxNoPopup) return;
  window.__hbxNoPopup = true;
  var SEL = '[class*="klaviyo-form-"],[class*="kl-private-reset"],[data-testid="POPUP"]';
  function floatingHost(el) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      var pos = getComputedStyle(n).position;
      if (pos === 'fixed' || pos === 'absolute') return n;
    }
    return null;
  }
  function sweep() {
    var found = document.querySelectorAll(SEL), n = 0;
    for (var i = 0; i < found.length; i++) {
      var host = floatingHost(found[i]);
      if (!host) continue;               // inline embed (footer signup) — leave alone
      host.style.setProperty('display', 'none', 'important');
      host.setAttribute('data-hbx-suppressed', '1');
      n++;
    }
    return n;
  }
  sweep();
  new MutationObserver(sweep).observe(document.documentElement, { childList: true, subtree: true });
  setInterval(sweep, 500);
  window.__hbxSweepPopups = sweep;
})();

/* Hobolax 09-30: Easy Bundle's SDK answers ANY failed bundle add (a sold-out size, a 429)
   by deleting EVERY cookie on the page — the cart cookie, _fbp/_ga, consent — then retrying
   into a brand-new cart. The shopper's existing cart silently vanishes while the open drawer
   keeps showing it; their next add then lands in the empty cart (Adam: "$6 to go" jumped to
   "$75.05 away"). Make the wipe a no-op so a failed add simply fails and the cart survives.
   The SDK calls gbbSdkHelpers.shopify.f.clearCookies() by property at call time, so
   swapping the property is enough. Polls because the SDK loads after this file. */
(function () {
  if (window.__hbxNoCookieWipe) return;
  window.__hbxNoCookieWipe = true;
  var tries = 0;
  (function patch() {
    var f = window.gbbSdkHelpers && window.gbbSdkHelpers.shopify && window.gbbSdkHelpers.shopify.f;
    if (f && typeof f.clearCookies === 'function') {
      f.clearCookies = function () {
        console.warn('[hbx] blocked Easy Bundle cookie wipe after a failed add');
        return Promise.resolve(false);
      };
      return;
    }
    if (++tries < 240) setTimeout(patch, 250); // up to 60s
  })();
})();
